import Vue from 'vue';
import SCAPayments from './components/Payments/SCAPayments.vue';

if (document.getElementById('sca-payment-form')) {
  new Vue({
    name: 'PaymentForm',
    el: '#sca-payment-form',
    template: '<SCAPayments />',
    components: {
      SCAPayments,
    },
  });
}
